import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=5eefdef1"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eefdef1')) {
      api.createRecord('5eefdef1', component.options)
    } else {
      api.reload('5eefdef1', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=5eefdef1", function () {
      api.rerender('5eefdef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Roles/Modal.vue"
export default component.exports